// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Editor_header__BNrzh {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  border-bottom: 1px solid #cfcfcf;
  padding-bottom: 15px;
}

.Editor_title__ZyCDX {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.Editor_label__e7rim {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}

.Editor_input__IHeFi,
  .Editor_input__IHeFi .ant-select-selector {
  background-color: #fbfbfb !important;
  border-color: #d2d2d2 !important;
  border-radius: 4px !important;
}

.Editor_itemColumn__qMhX3 {
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.Editor_itemSubmit__D93gY {
  margin-bottom: 0;
  text-align: right;
  margin-top: 20px;
}

.Editor_submit__1Nmxr {
  width: 250px;
  font-weight: 700;
  font-size: 13px;
}

.Editor_date__splug{
  display: flex;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/ratings/styles/Editor.module.css"],"names":[],"mappings":"AAAA;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;AACb","sourcesContent":[".header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 15px;\n    border-bottom: 1px solid #cfcfcf;\n    padding-bottom: 15px;\n  }\n  \n  .title {\n    color: var(--darkGray);\n    font-family: BebasNeue;\n    font-weight: 700;\n    font-size: 20px;\n  }\n  \n  .label {\n    font-weight: 500;\n    color: var(--darkGray);\n    font-size: 12px;\n  }\n  \n  .input,\n  .input :global(.ant-select-selector) {\n    background-color: #fbfbfb !important;\n    border-color: #d2d2d2 !important;\n    border-radius: 4px !important;\n  }\n  \n  .itemColumn {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n  }\n  \n  .itemSubmit {\n    margin-bottom: 0;\n    text-align: right;\n    margin-top: 20px;\n  }\n  \n  .submit {\n    width: 250px;\n    font-weight: 700;\n    font-size: 13px;\n  }\n  \n  .date{\n    display: flex;\n    width: 100%;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Editor_header__BNrzh`,
	"title": `Editor_title__ZyCDX`,
	"label": `Editor_label__e7rim`,
	"input": `Editor_input__IHeFi`,
	"itemColumn": `Editor_itemColumn__qMhX3`,
	"itemSubmit": `Editor_itemSubmit__D93gY`,
	"submit": `Editor_submit__1Nmxr`,
	"date": `Editor_date__splug`
};
export default ___CSS_LOADER_EXPORT___;
